export default __webpack_public_path__ + "static/2185-679749a88fafc719d274d82dffc3642d.jpg";